import { configureStore } from '@reduxjs/toolkit';
import buylistReducer, { BUYLIST_STORAGE_KEY } from './buylistSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    buylist: buylistReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Persist buylist state to localStorage with debounce
let previousBuylist = store.getState().buylist;
let saveTimeout: ReturnType<typeof setTimeout> | null = null;

store.subscribe(() => {
  const currentBuylist = store.getState().buylist;
  if (currentBuylist !== previousBuylist) {
    previousBuylist = currentBuylist;
    if (saveTimeout) clearTimeout(saveTimeout);
    saveTimeout = setTimeout(() => {
      try {
        localStorage.setItem(BUYLIST_STORAGE_KEY, JSON.stringify(currentBuylist));
      } catch (e) {
        console.warn('Failed to persist buylist cart to localStorage:', e);
      }
    }, 300);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
